import React from "react";

const EventsListChild = () => {
  return <div>EventsListChild</div>;
};

export default EventsListChild;
